import React from 'react'

const GroceryPaidClient = () => {
    return (
        <div>

        </div>
    )
}

export default GroceryPaidClient
